import React from 'react';
import Select, { components } from 'react-select';
//Imports Icons
import downArrow from '../assets/icons/downArrowWhite.svg';

// Genera una lista de opciones de años
const generateYearOptions = (startYear) => {
    const endYear = new Date().getFullYear() + 10;
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
        years.push({ value: year, label: year.toString() });
    }
    return years;
};

function YearSelect({ startYear, selectedYear, onYearChange }) {
    const yearOptions = generateYearOptions(startYear);

    const handleChange = (selectedOption) => {
        onYearChange(selectedOption ? selectedOption.value : null);
    };

    return (
        <article className='box-input flex'>
            <label htmlFor='region' className='hidden-label'>Año PME</label>
            <Select
                options={yearOptions}
                value={selectedYear ? { value: selectedYear, label: selectedYear.toString() } : null}
                onChange={handleChange}
                placeholder="Ingresar Año PME"
                className="custom-select"
                classNamePrefix="custom-select"
                components={{ DropdownIndicator }}
            />
        </article>
    );
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default YearSelect;
